import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input, OnDestroy
} from '@angular/core';
import {runtimeEventManager} from "@wm/core";
import {get, includes} from "lodash-es";
import {updateWidgetProps, WIDGET_CONSTANTS} from "@wm/components-base";
import {Subscription} from "rxjs";
@Directive({
  selector: '[wmListenProperty]',
  standalone: true,
})
export class ListenPropertyDirective implements AfterViewInit, OnDestroy{
  @Input() wmListenProperty: any;
  private registerDestroyListener = new Subscription();
  private el: HTMLElement;
  private componentInstance: any;
  private variableService: any;
  private liveWidgetUtils: any
  constructor() {
    let elRef = inject(ElementRef);
    this.el = elRef.nativeElement;
    this.variableService = runtimeEventManager.getService('variableService');
    this.liveWidgetUtils = runtimeEventManager.getService('LiveWidgetUtilsService');
  }

  ngOnInit() {
    this.registerPropertyChangeHandler();
  }

  ngAfterViewInit() {
    if (!this.componentInstance) {
      this.registerPropertyChangeHandler();
    }
  }

  registerPropertyChangeHandler() {
    this.componentInstance = get(this.el, 'widget');
    let wp = this.componentInstance.widgetProps;
    if (this.componentInstance) {
      let attrVal = this.el.getAttribute('wmListenProperty');
      if (attrVal === 'dataset' || attrVal === 'actions') {
        this.processListenPropValue();
        if (wp.groupby){
          this.setGroupByProp(wp);
        }
        if (wp.dateformat){
          this.showDateFormat(wp);
        }
      }
      this.componentInstance.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
        if (key === attrVal) {
          this.processListenPropValue();
        }
        if (key === 'match') {
          this.showDateFormat(wp, nv);
        }
        if (key === 'groupby') {
          this.setGroupByProp(wp, nv);
        }
      });
    }
  }

  processListenPropValue() {
    const dataset = this.componentInstance.binddataset || this.componentInstance.bindactions;
    const variableType = dataset? this.variableService.getVariableByName(dataset.split('.')[1])?.category: null;
    runtimeEventManager.emit('updatePropPanelOptions', this.componentInstance);

    //filter all the properties that are to be shown after variable binding
    const datasetShowProperties = Object.keys(this.componentInstance.widgetProps).filter((key) =>this.componentInstance.widgetProps[key].showondataset || this.componentInstance.widgetProps[key].showonvariable);

    //hide all dataset properties first to unset
    updateWidgetProps(this.componentInstance.widgetProps, false, datasetShowProperties);

    //filter properties based on the variable type.
    const currentDatasetShowProperties = Object.keys(this.componentInstance.widgetProps).filter((key) => {
      return variableType === this.componentInstance.widgetProps[key].showonvariable || this.componentInstance.widgetProps[key].showondataset===true;
    });
    updateWidgetProps(this.componentInstance.widgetProps, !!dataset, currentDatasetShowProperties);
  }

  setGroupByProp(wp: any, groupByVal?: any) {
    let groupbyVal = groupByVal || this.componentInstance.groupby || this.componentInstance.nativeElement.getAttribute('groupby');
    this.liveWidgetUtils.showOrHideMatchProperty(this.componentInstance, wp)
    if (groupbyVal && groupbyVal !== '') {
      if (groupbyVal === WIDGET_CONSTANTS.EVENTS.JAVASCRIPT) {
        wp.groupby.isGroupBy = true;
      } else {
        wp.groupby.isGroupBy = false;
      }
    }
  }

  showDateFormat(wp: any, nv?: any){
    let matchValue = nv || this.componentInstance.match;
    wp.dateformat.show = includes(['day', 'hour', 'month', 'week'], matchValue);
  }

  ngOnDestroy() {
    this.registerDestroyListener.unsubscribe();
    // runtimeEventManager.off();
  }
}

